import { PROBLEM_CODES, errorMessage, isProblemError, problemCode } from "../../api";

/**
 * Le texte à montrer quand la connexion échoue. Un seul message pour une
 * adresse inconnue et un mauvais mot de passe — c'est le serveur qui ne les
 * distingue pas, et le front n'a pas à broder.
 */
export function messageConnexion(err: unknown, restant: number): string {
  const delai = restant > 0 ? ` Réessayez dans ${restant} s.` : "";
  switch (problemCode(err)) {
    case PROBLEM_CODES.invalidCredentials:
      return "Adresse e-mail ou mot de passe incorrect.";
    case PROBLEM_CODES.accountLocked:
      return `Compte temporairement verrouillé après plusieurs échecs.${delai || " Réessayez dans quelques minutes."}`;
    case PROBLEM_CODES.rateLimited:
      return `Trop de tentatives depuis cet appareil.${delai}`;
    case PROBLEM_CODES.csrfRejected:
      return "La requête a été refusée par le contrôle d'origine. Rechargez la page et réessayez.";
    default:
      return isProblemError(err) ? err.detail : errorMessage(err);
  }
}
